import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//investor
const InvestorList = Loadable(lazy(() => import("pages/investor")));
const Details = Loadable(lazy(() => import("pages/investor/Details")));
const Investment = Loadable(lazy(() => import("pages/investor/Investment")));
const Receipt = Loadable(lazy(() => import("pages/investor/Receipt")));
const InvestorInvestmentReturn = Loadable(lazy(() => import("pages/investor/InvestmentReturn")));

const InvestorRoutes = {
  path: "investor",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <InvestorList />,
    },
    {
      path: "details/:id",
      element: <Details />,
    },
    {
      path: "investment",
      element: <Investment />,
    },
    {
      path: "investment/receipt/:id",
      element: <Receipt />,
    },
    {
      path: "return-investment",
      element: <InvestorInvestmentReturn />,
    },
  ],
};

export default InvestorRoutes;
